import React from 'react'

import { graphql } from 'gatsby'
import Layout from '../components/Layout'

import { TextPage } from '../components/TextPage'

const AboutUsPageTemplate = ({ data }: any) => {
  const page = data.markdownRemark

  return (
    <Layout title={`${page.frontmatter.pageTitle}`} description={page.frontmatter.pageDescription}>
      <TextPage content={page.html} {...page.frontmatter} />
    </Layout>
  )
}

export default AboutUsPageTemplate

export const pageQuery = graphql`
  query TermsAndConditionsPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "terms-and-conditions-page" } }) {
      html
      frontmatter {
        pageTitle
        pageDescription
        heading
        subheading
      }
    }
  }
`
